import { useRoutes } from 'react-router-dom';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { useAuthContext } from '../context/AuthContext/AuthContext';

export const AppRoutes = () => {
  const { userInfo } = useAuthContext();
  const routes = userInfo ? protectedRoutes(userInfo.role) : publicRoutes;

  const element = useRoutes([...routes]);

  return <>{element}</>;
};
